import script from "./ClassManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassManagement.vue?vue&type=script&setup=true&lang=js"

import "./ClassManagement.vue?vue&type=style&index=0&id=1a5cbf4e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a5cbf4e"]])

export default __exports__